<div class="core-selector" [ngClass]="class">

    <div [ngSwitch]="type">

      <div *ngSwitchCase="'checkbox'" class="view-filter-panel-checkbox">

        <ul class="nav flex-column list tree-list filter-option-list">
          <ng-template #recursiveList let-filterOptions>

            <li [ngClass]="{'dropdown': item.children && item.children.length > 0, 'd-none' : (key > (limit - 1)) && collapseLimitedItems}" class="tree-list-item list-item" *ngFor="let item of filterOptions; let key = index;">

              <div class="filter-option filter-option-checkbox">
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" [checked]="value && value.indexOf(item[selectorValue]) !== -1 ? true : false" />
                  <label class="custom-control-label" (click)="toggleCheckboxFilter(item[selectorValue])">{{item[selectorLabel] | translate}}</label>
                </div>
              </div>

              <div *ngIf="item.children && item.children.length > 0" class="list-item-collapse-toggle" (click)="toggleExpanded(item[selectorValue])">
                <i class="fa fa-chevron-down"></i>
              </div>

              <ul class="tree-sublist" [class.d-none]="!expandedItems.has(item[selectorValue])" *ngIf="item.children && item.children.length > 0">
                <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: item.children }"></ng-container>
              </ul>
            </li>

          </ng-template>

          <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: filterOptions }"></ng-container>
        </ul>

        <!-- toggle collapse items button -->
        <button class="btn btn-sm btn-outline-secondary mt-3" *ngIf="filterOptions.length > limit && collapseLimitedItems" (click)="collapseLimitedItems = !collapseLimitedItems">
          {{'Show more' | translate}}...
        </button>

        <button class="btn btn-sm btn-outline-secondary mt-3" *ngIf="filterOptions.length > limit && !collapseLimitedItems" (click)="collapseLimitedItems = !collapseLimitedItems">
          {{'Show less' | translate}}...
        </button>

      </div>

      <div *ngSwitchCase="'text'" class="view-filter-panel-text">

        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">{{'Filter' | translate}}</span>
            </div>
            <input type="text" class="form-control" [(ngModel)]="filterModelValue" />
            <div class="input-group-append">
              <button class="btn btn-primary" (click)="addFilterText(filterModelValue)">
                {{'Add' | translate}}
              </button>
            </div>

          </div>
        </div>

        <div class="tag-cloud tag-cloud-filter">

          <div class="tag-cloud-item" *ngFor="let textValue of value; let key = index;">
            <button class="btn btn-primary tag-cloud-btn" (click)="deleteFilterText(textValue)">
              {{textValue}}
              <i class="fa fa-times"></i>
            </button>

          </div>

        </div>

      </div>

    </div>


</div>
